import { IconButton } from "@/common/styles/style";
import SortIcon from "@mui/icons-material/Sort";
import SouthIcon from "@mui/icons-material/South";
import NorthIcon from "@mui/icons-material/North";

interface SortIconButtonProps {
  onSort: () => void;
  isAscending: boolean;
}

export default function SortIconButton({
  onSort,
  isAscending,
}: SortIconButtonProps) {
  return (
    <IconButton onClick={onSort}>
      {isAscending ? <NorthIcon /> : <SouthIcon />}
      <SortIcon />
    </IconButton>
  );
}
